import { fromJS, List, Map } from 'immutable';
import Geofence from '../../utils/models/Geofence';
import {
  SAVE_GEOFENCE,
  SET_DETAILED_GEOFENCE,
  V4_GEOFENCES_LOADED,
  V4_GEOFENCE_PRESENCE_CHANGED,
  WS_DATA_GEOFENCE,
  WS_DATA_GEOFENCE_PRESENCE,
  WS_DATA_GEOFENCES,
} from '../constants/geofence.constants';
import { AUTH_SUCCESS } from '../../containers/LoginPage/constants';
import Presence from '../../utils/models/Presence';

export const initialState = fromJS({
	data: {},
	// Separate slice so WS_DATA_GEOFENCES (V3-only) doesn't blow away V4.
	v4Geofences: List(),
	// v3SiteId -> v4SiteUuid.
	v4SiteMap: Map(),
	presence: {},
	detailedGeofence: null,
	loading: false,
	fetched: false
});

export default function GeofenceReducer(state: Map = initialState, action) {
	let geofences = state.get('data');
	switch (action.type) {
		case AUTH_SUCCESS:
			return initialState;
		case WS_DATA_GEOFENCE_PRESENCE:
			return state.set('presence', new Presence(action.data));
		case WS_DATA_GEOFENCE:
			return state.setIn(['data', action.data.id], new Geofence(action.data));
		case WS_DATA_GEOFENCES:
			geofences = Map(action.data.map(d => new Geofence(d)).map(d => [d.id, d]));
			return state.set('data', geofences).set('fetched', true);
		case V4_GEOFENCES_LOADED:
			return state
				.set('v4Geofences', List((action.geofences || []).map(g => new Geofence(g))))
				.set('v4SiteMap', Map(action.v4SiteMap || []));
		case V4_GEOFENCE_PRESENCE_CHANGED: {
			// Live entered/exited — flip the member's `present` flag in place.
			const list = state.get('v4Geofences') || List();
			const idx = list.findIndex(g =>
				String(g.get('id')) === String(action.geofenceId)
				|| String(g.get('uuid')) === String(action.geofenceId)
			);
			if (idx < 0) return state;
			const g = list.get(idx);
			const v4Data = g.get('v4Data') || {};
			const members = Array.isArray(v4Data.members) ? v4Data.members : [];
			let found = false;
			const newMembers = members.map(m => {
				if (String(m.device_id) !== String(action.deviceId)) return m;
				found = true;
				return { ...m, present: action.present };
			});
			if (!found) return state;
			return state.set(
				'v4Geofences',
				list.set(idx, g.set('v4Data', { ...v4Data, members: newMembers }))
			);
		}
		case SET_DETAILED_GEOFENCE:
			return state.set('detailedGeofence', action.geofence).set('loading', false);
		case SAVE_GEOFENCE:
			return state.set('loading', true);
		default:
			return state;
	}
}
